export default __webpack_public_path__ + "static/media/fran@2x.0fefd8f4.png";